import { createRouter, createWebHistory } from "vue-router";
import { routes } from "@/router/routes";
import { scrollBehavior } from "@/router/scrollBehavior";
import { registerGuards } from "@/router/registerGuards";

const router = createRouter({
  history: createWebHistory("/"),
  linkExactActiveClass: "active",
  routes,
  scrollBehavior,
});

registerGuards(router);

export { router };
